<script lang="ts">
  export let icon: string;
  export let size = 24;
  export let width = size;
  export let height = size;
  export let fill = "currentColor";
  export let stroke: string | null = null;
  export let style: string | null = null;
</script>

<svg {width} {height} {fill} {stroke} {style} aria-hidden="true">
  <use xlink:href="#{icon}" />
</svg>

<style>
  svg {
    display: block;
    transition:
      0.2s fill,
      0.2s stroke;
  }
</style>
